
import { Component, Prop, Vue } from "nuxt-property-decorator";
import LoadingSpinner from "~/components/molecules/display/LoadingSpinner.vue";

@Component({
  components: {
    LoadingSpinner,
  },
})
export default class BaseDataTile extends Vue {
  @Prop() headline: string;
  @Prop() description: string;
  @Prop() disclaimer: string;
  @Prop({ default: false }) showBatchLabel: boolean;
  @Prop({ default: false }) isLoading: boolean;
  @Prop({ default: "single" }) layoutType: string; // "single", "dual-horizontal", "dual-vertical"

  get layoutTypeClass() {
    return {
      "data-tile__grid--single": this.layoutType === "single",
      "data-tile__grid--dual-horizontal": this.layoutType === "dual-horizontal",
      "data-tile__grid--dual-vertical": this.layoutType === "dual-vertical",
    };
  }

  returnTrendDirectionString(trendValue: number) {
    const NumberTrendValue = Number(trendValue);
    if (NumberTrendValue === 0) return "right";
    if (NumberTrendValue < 0) return "sinking";
    if (NumberTrendValue > 0) return "rising";
    return "unknown";
  }

  returnRelatedBatchLabel(assetName: string) {
    if (assetName === "Brent") return "Eur/Barrel";
    if (assetName === "Gasöl") return "Eur/Tonne";
    return "";
  }
}
